import { createAction } from 'redux-actions';
import {
  ALL_PRODUCTS_DIRECTORY_FILTER_CHANGE,
} from './types';

export const changeFilter = createAction(ALL_PRODUCTS_DIRECTORY_FILTER_CHANGE, filter => filter);



/** WEBPACK FOOTER **
 ** ./web/js/actions/productsDirectory.js
 **/